import { TagModel } from "./TagModel";

export default class WDOperatorModel {
  id!: string;
  name!: string;
  loginSecret!: string;

  public tags: TagModel[] = [];

  constructor(data?: Partial<WDOperatorModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  public toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      loginSecret: this.loginSecret,
      tags: this.tags.map((tag) => tag.id)
    };
  }
}
